
import { ChatProviderType } from '../../../domain/chat/models/ChatProviderType';
import { IAssistantsProviderServices } from './interfaces/IAssistantsProviderServices';
import { AssistantsChatMessagesService } from './services/AssistantsChatMessagesService';
import { AssistantsChatSessionsService } from './services/AssistantsChatSessionsService';


export class AssistantsProviderServices implements IAssistantsProviderServices {
    public readonly providerType = ChatProviderType.Assistants;
    public readonly sessions;
    public readonly messages;

    constructor(baseUrl: string) {
        this.sessions = new AssistantsChatSessionsService(baseUrl);
        this.messages = new AssistantsChatMessagesService(baseUrl);

    }
}

